<template>
  <div>
    <x-grid :id="'formList'"
            :rowId="rowId"
            :pager-config="pagerConfig"
            :form-config="formConfig"
            :url="url"
            :columns="columns"
            :checkbox-config="checkboxConfig"
            :toolbar-config="toolbarConfig"
            :print-config="printConfig"
            :export-config="exportConfig"
            ref="grid"
            :cellClick="chooseRow"
            :cellDbClick="updateRow"
            @toolbar-addData="addRow"
            @toolbar-delData="delRow"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
        <vxe-button @click="edit()">更新编码</vxe-button>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
        title="修改经销商编号"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="1200"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <codingForm :rowId="-1"
                  :dealerId="editRowId"
                  v-if="editModalVisible"
                  ref="codingForm"
                  @cancelled="closeEdit()"
                  @saved="closeEdit(true)">
      </codingForm>
    </a-modal>

  </div>
</template>

<script>
import XGrid from '@/components/grid/XGrid';
import {GridMixin} from "@/utils/GridMixin";
import {
  formatter as fmt
} from "@/utils/ebase-formatter";
import api from '@/services/api';
import {loadBaseCodeData} from "@/services/baseCodeSource";
import codingForm from "@/pages/web/comm/dealerManage/codingForm";
console.info(fmt, loadBaseCodeData);//防止未用到报未定义错误 用到了可删除

import {mapState} from "vuex";

//弹出层组件


const fac = XGrid.factory;

//列表接口
const url = api.comm.DEALER
//主键
const rowId = 'deptId';

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumn("deptName", "经销商名称", 140),
  fac.makeColumn("dealerNo", "经销商编号", 140),
  fac.makeColumn("regionName", "所属经理部", 140),
  fac.makeColumn("mainDealerNameSimplify", "主数据经销商简称", 140),
  fac.makeColumn("mainDealerName", "主数据经销商全称", 100, 'center'),
  fac.makeColumn("isUseName", "是否使用", 160, 'center'),
  fac.makeColumn("provinceName", "省份", 100, 'center'),
  fac.makeColumn("cityName", "城市", 160, 'center'),
]


// 预加载函数 用来加载 列表查询中的通用代码 或其他代码
const formConfig = fac.makeFormConfig(columns, [
  {field: 'deptName'},
  {field: 'dealerNo'},
  {field: 'regionName'},
  {field: 'isUseName'},
  {field: 'provinceName'},
])


//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: false,
  import: false,
  delData: false,
  addData: false,
  templatelSlots: 'toolbarBtns'
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

export default {
  mixins: [GridMixin],
  components: {
    codingForm,
  },
  computed: {
    ...mapState('account', {currUser: 'user'}),
  },
  data() {
    return {
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
    }
  },
  methods: {
    add(){
      this.openEdit(0);
    },
    edit() {
      let rows = this.getRows();
      if (rows.length !== 1) {
        return this.$message.error('请选择一条数据');
      }
      this.editModalVisible = true;
      this.editRowId=rows[0].deptId
    },
  }
}
</script>

<style scoped>
</style>
